var E="app_refresh_id",e="Idempotence-Key";export{E as APP_REFRESH_ID,e as IDEMPOTENCE_KEY_HEADER_NAME};
//# sourceMappingURL=constants.js.map